module.exports = __webpack_public_path__ + "static/img/logo2.0b163861.png";